import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CheckBox, StatusWarning } from '_components';
import styles from './Common.module.css';


class AlTemplateManualRow extends React.Component {

    render() {
        return (
            <div className={styles.row}>
                <CheckBox
                    size='extra-small'
                    className={styles.checkbox}
                    checked={this.props.activity.selected}
                    title={this.props.desc}
                    label={this.props.desc}
                    onClick={() => this.props.toggleItem({ entity: 'MLTMPMANUAL', entityKeyColumn: 'XLTMPMANO', entityKeyValue: this.props.activity.XLTMPMANO })}
                />
                { !this.props.activity.valid &&
                    <span className={styles.warning}>
                        <StatusWarning size='extra-small' title='Not Reimbursable based on Payer/Contract' />
                    </span>
                }
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        toggleItem: bindActionCreators(noteActions.alTemplateToggleItem, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let activity = state.entities.notes.MLTMPMANUAL[ownprops.id];
    let maname = activity.XLTMPMAMANO ? state.entities.masterData.MLMASTERMANUAL[activity.XLTMPMAMANO].MANAME + ' - ' : '';
    let act = activity.XLTMPMAACTIVITY ? activity.XLTMPMAACTIVITY + ' - ' : '';
    let setsReps = activity.XLTMPMASETSREPS ? activity.XLTMPMASETSREPS + ' - ' : '';
    let desc = maname + act + setsReps;
    desc = desc.endsWith(' - ') ? desc.slice(0, -3) : desc;

    return {
        noteId: noteId,
        activity: activity,
        desc: desc
    };
}

const connectedAlTemplateManualRow = connect(mapStateToProps, mapDispatchToProps)(AlTemplateManualRow);
export { connectedAlTemplateManualRow as AlTemplateManualRow };

